import { app } from '@/common/api/apiClient'
import { API_ROUTES } from '@/common/constants'
import Blog from './types'

export async function fetchBlogs() {
    const res = await app.get(API_ROUTES.blogs)
    return res.data as { blogs: Blog[]; total?: number }
}

export async function fetchBlog(slug: string) {
    const res = await app.get(API_ROUTES.blog.replace('{}', encodeURIComponent(slug)))
    return res.data as Blog
}

export default {
    fetchBlogs,
    fetchBlog,
}
